import * as apiConstants from './apiUtilsConstants';
import { callAuthAPI } from './apiUtils';

export const registerUser = async (data = undefined, method = apiConstants.METHOD_POST) => {
  return callAuthAPI('register/user', data, method);
};

export const verifyRegistrationOtp = async (data = undefined, method = apiConstants.METHOD_POST) => {
  return callAuthAPI('register/user/verify-otp', data, method);
};

export const registerFirm = async (data = undefined, method = apiConstants.METHOD_POST) => {
  return callAuthAPI('register/firm', data, method);
};

export const registerFirmOAuth = async (data = undefined, method = apiConstants.METHOD_POST) => {
  return callAuthAPI('register/firmoauth', data, method);
};

export const forgotPassword = async (data = undefined, method = apiConstants.METHOD_POST) => {
  return callAuthAPI('user/forgotpassword', data, method);
};

export const resetPassword = async (data = undefined, method = apiConstants.METHOD_POST) => {
  return callAuthAPI('user/resetpassword', data, method);
};

export const changePassword = async (data) => {
  return callAuthAPI('user/changepassword', data, apiConstants.METHOD_POST, true);
};


export const toggleTwoFactor = async (enable) => {
  return callAuthAPI('user/toggle-2fa', { enable }, apiConstants.METHOD_POST, true);
};